//Imports node_modules
import React, { useState, useContext } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Import Data
import { globalModals } from "./GlobalModals";
import { globalVariables } from './GlobalVariables'


//Variaveis inicias
const initialState = {
    //Variaveis para a função advancedClick
    lastTouchTimeStamp: Date.now(),
    lastClickTimeStamp: Date.now(),
    dragTime: Date.now(),
}

export const axiosCalls = React.createContext(initialState)

const AxiosCalls = params => {

    const [state, setState] = useState(initialState)

    const {
        ShowMessageModal,
    } = useContext(globalModals)

    const { apiBaseUrl } = useContext(globalVariables)

    function axiosGet(url, receivedFunction) {
        axios.get(apiBaseUrl + url, { timeout: 50000 }).then((response) => {
            computResponse(response, receivedFunction, false)
        }, (error) => {
            alert('error')
        });
    }

    function axiosPost(url, messageType, message, receivedFunction,) {
        try{
            axios.post(apiBaseUrl + url, { timeout: 50000 }).then((response) => {
                computResponse(response, receivedFunction, messageType, message)
            }, (error) => {
               alert('error')
            });
        }catch(error){
            alert(error)
        }
       
    }

    function axiosPostObject(url, object, receivedFunction) {
        axios.post(apiBaseUrl + url, object, { timeout: 50000 }).then((response) => {
            computResponse(response, receivedFunction, false)
        }, (error) => {
            alert('error')
        });
    }

    function computResponse(response, receivedFunction, messageType, message) {
        const isDataAvailable = response.data && response.data.length;
        if (isDataAvailable) {
            const myJSON = JSON.stringify(response.data);
            if (myJSON.slice(0, 6) === '"Erro:') {
                ShowMessageModal(
                    {
                        modaltype: 'error',
                        modalTitle: 'Erro na execução',
                        modalMessage: response.data,
                        nextClick: 'dismiss',
                        nextBtnTxt: 'Compreendi',
                        crossClick: 'dismiss',
                        centered: true,
                    }
                )
            } else {
                //Operação a executar
                receivedFunction(response)
            }
        } else {
            switch (messageType) {
                case 'message':
                    ShowMessageModal(
                        {
                            modaltype: 'warning',
                            modalTitle: 'Atenção!',
                            modalMessage: message,
                            nextClick: 'dismiss',
                            nextBtnTxt: 'Compreendi',
                            crossClick: 'dismiss',
                            centered: true,
                        })
                    break;
                case 'warning':
                    toast.warn(message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    break;
                case 'function':
                    message(response)
                    break;
                case 'hidden':
                    break;
                default:
                    break;
            }
        }
    }

    return (
        <axiosCalls.Provider value={{
            //---Variaveis
            //Variaveis para a função advancedClick
            lastTouchTimeStamp: state.lastTouchTimeStamp,
            lastClickTimeStamp: state.lastClickTimeStamp,
            dragTime: state.dragTime,

            //---Fim Variaveis

            //---Funções
            //t = text, n = number, a = object/array b= boolean, d= date

            //Click functions
            AxiosGet: (url, receivedFunction) => axiosGet(url, receivedFunction),
            AxiosPost: (url, messageType, message, receivedFunction) => axiosPost(url, messageType, message, receivedFunction),
            AxiosPostObject: (url, object, receivedFunction) => axiosPostObject(url, object, receivedFunction),
            ComputResponse: (response, receivedFunction) => computResponse(response, receivedFunction),

            //Fim Funções
        }}>
            {params.children}
        </axiosCalls.Provider>
    )
}

export default AxiosCalls